import { checkIfChannelIsBlocked } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { setLiveMenuOptions } from 'containers/NewSearchPage/redux/actions/searchActions';
import { getChannelFromEpg } from 'containers/NewSearchPage/utils/getChannelFromEpg';
import {
  EPG_SET_CURRENT_CHANNEL,
  SET_EVENT_FROM_EPG,
} from 'containers/Player/actions/liveMenu/constants';
import buttonOptionClick from 'containers/Player/actions/optionButtons/optionButtons.actions';
import { getTimeShift } from 'containers/Player/utils/PlayRules';
import { browserHistory } from 'react-router';
import React from 'react';
import qs from 'qs';
import { useDispatch, useSelector } from 'react-redux';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { getRegion } from 'utils/Region';
import Utils from 'utils/Utils';
import { useNavigate } from 'react-router-dom';


export const useHandlePlayContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const linealChannel = useSelector(state => state.linealChannel?.data);

  const handlePlayOnMobile = groudId => {
    // verificamos si estamos en mobile
    if (Utils.MobileCheck()) {
      const goTo = ClaroUrlBuilder.mobileGoToApp(getRegion(), groudId, false);
      return document.location.assign(goTo);
    }
  };

  const handleFutureEvent = (groupId, eventFromEpg, eventInfo) => {
    handlePlayOnMobile(groupId);
    const channelFromEpg = getChannelFromEpg(eventInfo?.channel_group_id);

    //ABRIR MENU DE OPCIONES EN EVENTOS LIVE FUTUROS
    const channel = {
      id: eventInfo?.channel_id || channelFromEpg?.id,
      image: channelFromEpg?.image,
      group_id: eventInfo?.channel_group_id || channelFromEpg?.group_id,
      name: eventInfo?.channel_name || channelFromEpg?.name,
      group: eventInfo?.channel_group || channelFromEpg?.group,
      number: eventInfo?.channel_number || channelFromEpg?.number,
      liveref: eventInfo?.channel_liveref || channelFromEpg?.liveref,
      provider_metadata_id: eventInfo?.channel_provider_metadata_id || channelFromEpg?.provider_metadata_id,
      provider_metadata_name: eventInfo?.channel_provider_metadata_name || channelFromEpg?.provider_metadata_name,
    };

    dispatch(
      setLiveMenuOptions({
        channel,
        event: {
          ...eventInfo,
          date_end: eventInfo?.endtime,
          date_begin: eventInfo?.begintime,
        },
      }),
    );
    //SETEAR en TRUE EL MODAL DE OPCIONES LIVE
    dispatch(buttonOptionClick('options'));
    //SETEAR LA INFO DEL EVENTO FUTURO
    dispatch({
      type: EPG_SET_CURRENT_CHANNEL,
      payload: eventInfo?.channel_group_id,
    });
    dispatch({
      type: SET_EVENT_FROM_EPG,
      payload: eventFromEpg || eventInfo,
    });

    //VERIFICAR SI EL CANAL ESTA BLOQUEADO
    dispatch(
      checkIfChannelIsBlocked({
        group_id: groupId,
        onSuccess: () => navigate(`/${getRegion()}/watch/${groupId}`),
      }),
    );
  };

  const handleNowEvent = groupId => {
    handlePlayOnMobile(groupId);
    //VERIFICA SI EL CONTENIDO ESTA BLOQUEADO
    dispatch(
      checkIfChannelIsBlocked({
        group_id: groupId,
        onSuccess: () =>
        navigate(`/${getRegion()}/watch/${groupId}`),
      }),
    );
  };

  const handlePastEvent = (groudId, eventInfo, channel) => {
    handlePlayOnMobile(groudId);
    //Verificar si el evento esta dentro del mergen de timeshift
    const maxTimeshiftHours = getTimeShift(groudId, linealChannel);
    const channelHasTimeshift = parseInt(channel?.group?.common?.timeshift) > 0;
    const catchupIsEnable =
      maxTimeshiftHours !== 0 &&
      channelHasTimeshift &&
      eventInfo?.ext_catchup === '1';
    const endDate = eventInfo?.unix_end * 1000;
    const tsStart = Date.now() - maxTimeshiftHours;
    const eventIsAlowToPlayFromTimeshiftRange = endDate > tsStart;

    if (catchupIsEnable) {
      if (eventIsAlowToPlayFromTimeshiftRange) {
        //revisar si el evento inicia entes del margen
        return dispatch(
          checkIfChannelIsBlocked({
            group_id: groudId,
            onSuccess: () => {
              let query;
              if (
                eventInfo?.unix_begin * 1000 >
                Date.now() - maxTimeshiftHours
              ) {
                query = {
                  startTime: `${eventInfo?.unix_begin}0000000`,
                  endTime: `${eventInfo?.unix_end}0000000`,
                };
                // router.push(`/${router.params.country}${PLAYER_SEGMENT}${channel.group_id}`);
              } else {
                query = {
                  startTime: `${Date.now() - maxTimeshiftHours}0000`,
                  endTime: `${eventInfo?.unix_end}0000000`,
                };
              }
              let replaceUrl = `/${getRegion()}/watch/${groudId}`;
              if (maxTimeshiftHours > 0) {
                replaceUrl += `?${qs.stringify(query)}`;
              }
              navigate(replaceUrl);
            },
          }),
        );
      }
    }
    return handleNowEvent(groudId);
  };

  return {
    handleFutureEvent,
    handlePlayOnMobile,
    handleNowEvent,
    handlePastEvent,
  };
};
